export enum FontFamilyNames {
    poppins = 'Poppins',
    segoeUI = 'SegoeUI'
}
